import { Box, Typography, Fade } from '@mui/material';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import info from '../../Images/info.png';
import { useState } from 'react';
import PropTypes from 'prop-types';

const EdgeInfoBox = () => {
  const [hovered, setHovered] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const edgeData = [
    {
      type: 'dot',
      color: '#2196F3',
      description: 'Mapped by fuzzy logic with valid datatypes',
    },
    {
      type: 'line',
      color: '#2196F3',
      dashed: false,
      description: 'Mapped manually using function nodes',
    },
    {
      type: 'line',
      color: 'green',
      dashed: false,
      description: 'Manual direct mapping (source to destination)',
    },
    {
      type: 'line',
      color: '#FF0000',
      dashed: false,
      description: 'Manual direct mapping with datatype mismatch',
    },
  ];

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      <img
        src={info}
        alt="info"
        width={25}
        height={25}
        style={{ cursor: 'pointer' }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      />

      <Fade in={hovered}>
        <Box
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => {
            setHovered(false);
            setHoveredIndex(null);
          }}
          sx={{
            position: 'absolute',
            top: '2.2rem',
            left: 0,
            width: 340,
            backgroundColor: '#f9fbff',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
            borderRadius: 2,
            p: 2,
            zIndex: 100,
            border: '1px solid #d0d7e2',
            fontSize: '0.875rem',
          }}
        >
          <Typography variant="body1" fontWeight="500" gutterBottom>
            Edge Details
          </Typography>

          {edgeData.map((item, index) => (
            <Box
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                py: 1,
                px: 1.5,
                borderRadius: 1,
                backgroundColor:
                  hoveredIndex === index
                    ? '#e1e9f9'
                    : index % 2 === 0
                    ? '#ffffff'
                    : '#f0f4f8',
                mb: 1,
                transition: 'background-color 0.3s ease',
                cursor: 'default',
                fontSize: '0.675rem',
              }}
            >
              {item.type === 'dot' ? (
                <EdgeDot color={item.color} expanded={hoveredIndex === index} />
              ) : (
                <EdgeLine
                  color={item.color}
                  dashed={item.dashed}
                  expanded={hoveredIndex === index}
                />
              )}
              <Typography sx={{ fontSize: '0.675rem' }}>
                {item.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Fade>
    </Box>
  );
};

// Dot-style edge indicator
const EdgeDot = ({ color, expanded }) => (
  <Box
    sx={{
      display: 'inline-block',
      width: expanded ? 50 : 30,
      height: 0,
      borderBottom: `2px dotted ${color}`,
      mr: 1.5,
      verticalAlign: 'middle',
      transition: 'width 0.3s ease',
    }}
  />
);

EdgeDot.propTypes = {
  color: PropTypes.string.isRequired,
  expanded: PropTypes.bool,
};

// Line-style edge indicator
const EdgeLine = ({ color, dashed, expanded }) => (
  <Box
    sx={{
      display: 'inline-block',
      width: expanded ? 50 : 30,
      height: 0,
      borderBottom: dashed ? `2px dotted ${color}` : `2px solid ${color}`,
      mr: 1.5,
      verticalAlign: 'middle',
      transition: 'width 0.3s ease',
    }}
  />
);

EdgeLine.propTypes = {
  color: PropTypes.string.isRequired,
  dashed: PropTypes.bool,
  expanded: PropTypes.bool,
};

export default EdgeInfoBox;
